import { Box, Paper } from '@mui/material';
import { useState } from 'react';
import {
  FORM_ACTION,
  useDataProvider,
  useSnackbar,
  useUserAccess,
} from '@ui-framework/index';
import { nanoid } from 'nanoid';
import SpecialSchedulesList from './components/SpecialSchedulesList/index';
import SpecialScheduleForm from './components/SpecialScheduleForm';

function SpecialSchedules({
  serviceProviderId,
  locationId = null,
  mode = FORM_ACTION.LIST,
  selectedScheduleId,
}) {
  const snackbar = useSnackbar();
  const userAccess = useUserAccess();

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { put, get, post, remove, getApiUrl } = useDataProvider(provider);

  const [listRefreshKey, setlistRefreshKey] = useState(nanoid());
  const readOnly = userAccess.isUserReadonly();

  const commonParams = {
    snackbar,
    put,
    get,
    post,
    remove,
    getApiUrl,
    pageId: serviceProviderId,
  };

  const refreshListView = () => {
    setlistRefreshKey(nanoid());
  };

  return (
    <Box>
      {[FORM_ACTION.EDIT, FORM_ACTION.CREATE].includes(mode) && (
        <Paper variant="outlined" sx={{ mb: 2, mt: 2 }}>
          <SpecialScheduleForm
            params={commonParams}
            selectedScheduleId={selectedScheduleId}
            refreshListView={refreshListView}
            readOnly={readOnly}
            locationId={locationId}
            mode={mode}
          />
        </Paper>
      )}
      {[FORM_ACTION.LIST].includes(mode) && (
        <Paper variant="outlined" sx={{ mb: 2, mt: 2 }}>
          <SpecialSchedulesList
            key={listRefreshKey}
            params={commonParams}
            selectedScheduleId={selectedScheduleId}
            refreshListView={refreshListView}
            readOnly={readOnly}
            locationId={locationId}
            mode={mode}
          />
        </Paper>
      )}
    </Box>
  );
}

export default SpecialSchedules;
